<form autocomplete="off" class="form" (submit)="onSubmit($event)">
  <div class="field is-narrow">
    <label class="label" translationEditableDirective="IMAGE_BASE_URL">{{"IMAGE_BASE_URL" | translate}}</label>
    <div class="control">
      <input
        class="input"
        name="imageBaseUrl"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['imageBaseUrl'])"
        [ngClass]="{ 'is-danger': hasError('imageBaseUrl') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('imageBaseUrl')">
      {{ getError('imageBaseUrl') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="IMAGE_UPLOAD_PATH">{{"IMAGE_UPLOAD_PATH" | translate}}</label>
    <div class="control">
      <input
        class="input"
        name="imageUploadPath"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['imageUploadPath'])"
        [ngClass]="{ 'is-danger': hasError('imageUploadPath') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('imageUploadPath')">
      {{ getError('imageUploadPath') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="RDN_GENERATION_PATH">{{"RDN_GENERATION_PATH" | translate}}</label>
    <div class="control">
      <input
        class="input"
        name="rdnGenerationPath"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['rdnGenerationPath'])"
        [ngClass]="{ 'is-danger': hasError('rdnGenerationPath') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('rdnGenerationPath')">
      {{ getError('rdnGenerationPath') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="PROPERTY_DOCUMENT_UPLOAD_PATH">{{"PROPERTY_DOCUMENT_UPLOAD_PATH" | translate}}</label>
    <div class="control">
      <input
        class="input"
        name="propertyDocumentUploadPath"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['propertyDocumentUploadPath'])"
        [ngClass]="{ 'is-danger': hasError('propertyDocumentUploadPath') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('propertyDocumentUploadPath')">
      {{ getError('propertyDocumentUploadPath') }}
    </p>
  </div>

  <div class="field is-grouped">
    <div class="control">
      <button [disabled]="isLoading" type="submit" class="button is-link" translationEditableDirective="SAVE">{{"SAVE" | translate}}
      </button>
    </div>
  </div>
</form>
